<template>
    <div class="w-full" :class="{'overflow-y-auto' : scrollable}" :style="{'height' : height}">
        <div v-if="loading" class="">
            <global-skeleton v-for="index in loadingList" :loadingType="loadingType" :key="index"></global-skeleton>
        </div>
        <slot v-else></slot>
    </div>
</template>

<script>
export default {
    props :{
        loading : {
            type : Boolean,
            default : false
        },
        loadingList : {
            type : Number,
            default : 1
        },
        loadingType : {
            type : String,
            default : 'avatar-two-line'
        },
        scrollable : {
            type : Boolean,
            default : false
        },
        height : {
            type : String,
            default : 'auto'
        },
    },
}
</script>